export default __webpack_public_path__ + "static/media/l_2.9fd6ea22.jpg";